import { useCallback } from 'react';

type InputType = string | boolean | number;
type CapitalizeFunction = (text: InputType | undefined) => InputType;

const useCapitalLetter = (): CapitalizeFunction => {
  const capitalize = useCallback<CapitalizeFunction>((text) => {
    if (typeof text === 'string') {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    return text;
  }, []);

  return capitalize;
};

export default useCapitalLetter;